import { action } from "../const";

let initialState = {
    etoken: undefined,
    templateChild: undefined,
    templateParent: undefined,
    templateGrandparent: undefined,
    templateMentor:  undefined,
    templateTeacher:  undefined,
}

export default function InviteReducer(state = initialState, data) {

    switch (data.type) {

        case action.INVITE_E_TOKEN:
            return {
                ...state,
                etoken: data.etoken
            }

        case action.INVITE_MESSAGE_TEMPLATE:
            return {
                ...state,
                [data.role]: data.message
            }

        default:
            break;
    }
    return state;
}